/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Stack, Dropdown, TextField } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { validateBidAdjustment, getValidateBidAdjustmentErrorMsg } from './utility';
import { ErrorString } from './shared';

export const BidAdjustment = (props) => {
  const i18n = useContext(I18nContext);
  const {
    data,
    adjustmentDropdown,
    adjustmentInput,
    handleChangeInput,
    handleBatchChangeInput,
    isDirty,
    index,
    keySuffix,
    item,
    column,
    setIsDirty,
    disableDecrease,
  } = props;

  const dropdownOption = disableDecrease ? [
    { key: 'Increase by', text: i18n.getString(_TL_('Increase by')) },
  ] : [
    { key: 'Increase by', text: i18n.getString(_TL_('Increase by')) },
    { key: 'Decrease by', text: i18n.getString(_TL_('Decrease by')) },
  ];

  const {
    min, max, extra, onlyExtra,
  } = column;
  const [bidAdjustmentError, setBidAdjustmentError] = useState('');
  const [adjustmentDropdownValue, setAdjustmentDropdownValue] = useState('');
  const [currentKeySuffix, setCurrentKeySuffix] = useState('');

  useEffect(() => {
    let validateValue = item.bidAdjustmentInput;
    if (adjustmentDropdownValue === 'Decrease by') {
      validateValue = -item.bidAdjustmentInput;
    }
    // When the valid value range or input value changes, check again
    setBidAdjustmentError(getValidateBidAdjustmentErrorMsg({
      code: validateBidAdjustment({
        value: validateValue, min, max, extra, onlyExtra,
      }),
      i18n,
      min,
      max,
      extra,
      onlyExtra,
    }));
  }, [item[column.fieldName], min, max, extra, onlyExtra, adjustmentDropdownValue]);

  useEffect(() => { setAdjustmentDropdownValue(adjustmentDropdown); }, [adjustmentDropdown]);
  useEffect(() => { setCurrentKeySuffix(keySuffix); }, [keySuffix]);

  const handleBlur = (value) => {
    let tempValue = value - 0;
    if (!disableDecrease && !isNaN(tempValue) && tempValue < 0) {
      tempValue = -tempValue;
      setCurrentKeySuffix(new Date().getTime());
      let tempAdjustmentDropdownValue = '';
      if (adjustmentDropdownValue === 'Decrease by') {
        tempAdjustmentDropdownValue = 'Increase by';
      } else {
        tempAdjustmentDropdownValue = 'Decrease by';
      }
      setAdjustmentDropdownValue(tempAdjustmentDropdownValue);
      handleBatchChangeInput({ bidAdjustmentInput: tempValue, bidAdjustmentDropdown: tempAdjustmentDropdownValue });
    } else {
      handleChangeInput('bidAdjustmentInput', value);
    }
  };

  return (
    <Fragment>
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }} className="bid-adjustment-wrapper">
        <Dropdown
          className="bid-adjustment-dropdown"
          aria-label="bid-adjustment-dropdown-label"
          options={dropdownOption}
          selectedKey={adjustmentDropdownValue}
          onChange={(_e, option) => {
            if (!isDirty[`bidAdjustmentDropdown-${index}`]) {
              setIsDirty({ ...isDirty, [`bidAdjustmentDropdown-${index}`]: true });
            }
            handleChangeInput('bidAdjustmentDropdown', option.key);
          }}
          styles={{
            dropdown: { width: 135 },
            dropdownOptionText: { overflow: 'visible', whiteSpace: 'normal' },
            dropdownItem: { height: 'auto' },
            dropdownItemSelected: { height: 'auto' },
          }}
          disabled={data.useParentLevel}
        />
        <TextField
          className={`bid-adjustment-input ${!data.useParentLevel && isDirty[`bidAdjustmentInput-${index}`] && bidAdjustmentError ? 'input-error-border' : ''}`}
          ariaLabel="bid-adjustment-input-label"
          defaultValue={adjustmentInput}
          key={`${column.fieldName}-${index}-${currentKeySuffix}`}
          onChange={(_e, value) => {
            if (!isDirty[`bidAdjustmentInput-${index}`]) {
              setIsDirty({ ...isDirty, [`bidAdjustmentInput-${index}`]: true });
            }
            let validateValue = value;
            if (adjustmentDropdownValue === 'Decrease by') {
              validateValue = -value;
            }
            const err = getValidateBidAdjustmentErrorMsg({
              code: validateBidAdjustment({
                value: validateValue, min, max, extra, onlyExtra,
              }),
              i18n,
              min,
              max,
              extra,
              onlyExtra,
            });
            setBidAdjustmentError(err);
          }}
          onBlur={e => handleBlur(e.target.value)}
          disabled={data.useParentLevel}
        />
        <span className="bidBoost-percent">%</span>
      </Stack>
      {!data.useParentLevel && isDirty[`bidAdjustmentInput-${index}`] && bidAdjustmentError && <ErrorString error={bidAdjustmentError} />}
    </Fragment>
  );
};

BidAdjustment.propTypes = {
  data: PropTypes.shape({}).isRequired,
  item: PropTypes.shape({}).isRequired,
  adjustmentDropdown: PropTypes.string,
  adjustmentInput: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChangeInput: PropTypes.func.isRequired,
  handleBatchChangeInput: PropTypes.func.isRequired,
  isDirty: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
  keySuffix: PropTypes.number.isRequired,
  column: PropTypes.shape({}).isRequired,
  setIsDirty: PropTypes.func.isRequired,
  disableDecrease: PropTypes.bool,
};

BidAdjustment.defaultProps = {
  adjustmentDropdown: '',
  adjustmentInput: '',
  disableDecrease: false,
};
